import React, { useEffect, useState } from 'react'
import styles from "./video.module.css"
import { MdPlayArrow } from 'react-icons/md'
import MediaUnavailable from '../MediaUnavailable'

const Video = ({ url, width, height, showPreview, quotedMessage, showPlayAction = true, openPreview = () => { } }) => {
    const [failed, setFailed] = useState(false)
    const style = showPreview ? { aspectRatio: width > 0 && height > 0 ? `${width} / ${height}` : undefined } : {}

    useEffect(() => setFailed(false), [url])

    if (failed) {
        return <MediaUnavailable type="video" compact={quotedMessage} onRetry={() => setFailed(false)} />
    }

    return (
        <div className={styles.container} onClick={() => openPreview(showPreview)}>
            <video src={url} aria-label="Vídeo" controls={!showPreview && !quotedMessage} preload="metadata" style={style} onError={() => setFailed(true)} />
            {showPreview && !quotedMessage && showPlayAction &&
                <div className={styles.arrowPlay}>
                    <MdPlayArrow />
                </div>
            }
        </div>
    )
}

export default Video
